import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import * as globalVariables from "../../commonVariableList/addInvoice";
import { ToasterService } from 'angular2-toaster';
import { WebServiceService } from '../../shared/services/web-service.service';
import { LocalStorageService } from '../../shared/services/storage/local-storage.service';
@Component({
  selector: 'app-generic-accordion-items',
  templateUrl: './generic-accordion-items.component.html',
  styleUrls: ['./generic-accordion-items.component.scss']
})
export class GenericAccordionItemsComponent implements OnInit {
  @Input() tableDetails: any;
  @Input() approvalDetails: any;

  commonVariableList: any = { "columnList": [], "items": [], "approvals": [] }
  company_setup: any = {};
  isProcessing:boolean=true;
  @Output()
  sendAction = new EventEmitter()
  constructor(private toasterService: ToasterService, private webService: WebServiceService,public _localStorageService: LocalStorageService) { }
  companyThemeBlockColor: any = "";
  CompanyThemetextColor: any = "";
  private resolveInvoiceItemOcrLineIndex(item: any, fallbackIndex: number = 0): number {
    if (item && item.ocr_line_index !== undefined && item.ocr_line_index !== null && item.ocr_line_index !== '') {
      const parsed = parseInt(String(item.ocr_line_index), 10);
      return isNaN(parsed) ? fallbackIndex : parsed;
    }
    if (item && item.row_no !== undefined && item.row_no !== null && item.row_no !== '') {
      const rowParsed = parseInt(String(item.row_no), 10);
      return isNaN(rowParsed) ? fallbackIndex : rowParsed - 1;
    }
    return fallbackIndex;
  }

  private compareInvoiceItemsByOcrLineIndex(a: any, b: any): number {
    return this.resolveInvoiceItemOcrLineIndex(a, 0) - this.resolveInvoiceItemOcrLineIndex(b, 0);
  }

  ngOnInit() {
    if (this.tableDetails.id) {
      this.commonVariableList.items = [];
      this.GetCompanySetUpData();
    }
    this.companyThemeBlockColor = this._localStorageService.getCompanyTheme() ? this._localStorageService.getCompanyTheme() : "#035168";
    this.CompanyThemetextColor = this._localStorageService.getCompanyThemeColor() ? this._localStorageService.getCompanyThemeColor() : "#FFFFFF";
  }
  GetCompanySetUpData() {
    if (this.company_setup.product_catalog_id != undefined && this.company_setup.product_catalog_id != '') {
      return false;
    }
    let req = {
    }
    this.company_setup = {}
    this.isProcessing=true;
   this.webService.commonPostMethod("Update_company_meta/ajax_getall_bycompany", req).subscribe(
      data => {
        if (data.status) {
          this.company_setup = {}
          this.company_setup = data.response ? data.response : {}
          this.company_setup.is_boq_qty_editable_in_pr=this.company_setup.is_boq_qty_editable_in_pr?this.company_setup.is_boq_qty_editable_in_pr:'0';

          this.company_setup.default_currency_code=this.company_setup.default_currency_code?this.company_setup.default_currency_code:'INR';

          this.company_setup.is_show_open_qty_button_visible_at_raise_time = this.company_setup.is_show_open_qty_button_visible_at_raise_time ? this.company_setup.is_show_open_qty_button_visible_at_raise_time : '0';

          this.company_setup.generice_ui_paragraph_color_code= this.company_setup.generice_ui_paragraph_color_code? this.company_setup.generice_ui_paragraph_color_code:'#53a75c';
          this.company_setup.allowed_digits_after_decimal = this.company_setup.allowed_digits_after_decimal ? this.company_setup.allowed_digits_after_decimal : "2";

          this.company_setup.generice_ui_heading_color_code= this.company_setup.generice_ui_heading_color_code? this.company_setup.generice_ui_heading_color_code:'#333';

          if (this.company_setup.product_catalog_id != undefined && this.company_setup.product_catalog_id != '') {
            this.company_setup.product_catalog_id = '1'
          }
          this.company_setup.product_catalog_id = this.company_setup.product_catalog_id ? this.company_setup.product_catalog_id : '0';
          this.company_setup.product_catalog_id_one = this.company_setup.product_catalog_id_one ? this.company_setup.product_catalog_id_one : '0';
          this.company_setup.is_rejected_qty_visible_in_direct_invoice=  this.company_setup.is_rejected_qty_visible_in_direct_invoice?  this.company_setup.is_rejected_qty_visible_in_direct_invoice:'0'


          this.company_setup.is_procured_days_po_visible = this.company_setup.is_procured_days_po_visible ? this.company_setup.is_procured_days_po_visible : '0'
          this.company_setup.is_lead_time_po_visible = this.company_setup.is_lead_time_po_visible ? this.company_setup.is_lead_time_po_visible : '0'
          this.company_setup.is_inventory_in_hand_po_visible = this.company_setup.is_inventory_in_hand_po_visible ? this.company_setup.is_inventory_in_hand_po_visible : '0'
          this.company_setup.is_average_daily_consumption_po_visible = this.company_setup.is_average_daily_consumption_po_visible ? this.company_setup.is_average_daily_consumption_po_visible : '0'
          this.company_setup.is_current_stock_po_visible = this.company_setup.is_current_stock_po_visible ? this.company_setup.is_current_stock_po_visible : '0'

          this.company_setup.pr_formula_inventory_in_hand = this.company_setup.pr_formula_inventory_in_hand ? this.company_setup.pr_formula_inventory_in_hand : '0'
          this.company_setup.pr_formula_procured_days = this.company_setup.pr_formula_procured_days ? this.company_setup.pr_formula_procured_days : '0'
          this.company_setup.pr_lead_time_auto_fetch = this.company_setup.pr_lead_time_auto_fetch ? this.company_setup.pr_lead_time_auto_fetch : '0'
          this.company_setup.is_average_daily_consumption_editable = this.company_setup.is_average_daily_consumption_editable ? this.company_setup.is_average_daily_consumption_editable : '0'
          this.company_setup.is_current_stock_editable = this.company_setup.is_current_stock_editable ? this.company_setup.is_current_stock_editable : '0'
          this.company_setup.is_lead_time_editable = this.company_setup.is_lead_time_editable ? this.company_setup.is_lead_time_editable : '0'
          this.company_setup.average_consumption_frequency_name = this.company_setup.average_consumption_frequency_name ? this.company_setup.average_consumption_frequency_name : 'Average Monthly Consumption'
          this.company_setup.is_formula_required_for_require_by_date = this.company_setup.is_formula_required_for_require_by_date ? this.company_setup.is_formula_required_for_require_by_date : '0'
          this.company_setup.pr_procured_days_name = this.company_setup.pr_procured_days_name ? this.company_setup.pr_procured_days_name : 'No Of Months Requested For'
          this.company_setup.pr_inventory_in_hand_name = this.company_setup.pr_inventory_in_hand_name ? this.company_setup.pr_inventory_in_hand_name : 'Inventory In Hand(Months)'



          // po
          this.company_setup.is_discount_applicable_in_po = this.company_setup.is_discount_applicable_in_po ? this.company_setup.is_discount_applicable_in_po : '0'
          this.company_setup.discount_type_in_po = this.company_setup.discount_type_in_po ? this.company_setup.discount_type_in_po : ''

          this.company_setup.is_service_start_end_date_visible = this.company_setup.is_service_start_end_date_visible ? this.company_setup.is_service_start_end_date_visible : '0'
          this.company_setup.currency_icon = this.company_setup.currency_icon ? this.company_setup.currency_icon : '';

          this.company_setup.is_pr_unit_price_visible = this.company_setup.is_pr_unit_price_visible ? this.company_setup.is_pr_unit_price_visible : '0'
          this.company_setup.is_current_stock_visible = this.company_setup.is_current_stock_visible ? this.company_setup.is_current_stock_visible : '0'
          this.company_setup.is_average_daily_consumption_visible = this.company_setup.is_average_daily_consumption_visible ? this.company_setup.is_average_daily_consumption_visible : '0'
          this.company_setup.is_inventory_in_hand_visible = this.company_setup.is_inventory_in_hand_visible ? this.company_setup.is_inventory_in_hand_visible : '0'
          this.company_setup.is_lead_time_visible = this.company_setup.is_lead_time_visible ? this.company_setup.is_lead_time_visible : '0'
          this.company_setup.is_procured_days_visible = this.company_setup.is_procured_days_visible ? this.company_setup.is_procured_days_visible : '0'
          this.company_setup.is_moq_visible = this.company_setup.is_moq_visible ? this.company_setup.is_moq_visible : '0'
          this.company_setup.merge_grn_irn = this.company_setup.merge_grn_irn ? this.company_setup.merge_grn_irn : '0';
          this.company_setup.is_product_owned_type_invoice_visible = this.company_setup.is_product_owned_type_invoice_visible ? this.company_setup.is_product_owned_type_invoice_visible : '0';
          this.company_setup.average_consumption_frequency_name_in_ir = this.company_setup.average_consumption_frequency_name_in_ir ? this.company_setup.average_consumption_frequency_name_in_ir : 'Average Monthly Consumption'

          this.company_setup.is_invoice_qty_visible_in_irn = this.company_setup.is_invoice_qty_visible_in_irn ? this.company_setup.is_invoice_qty_visible_in_irn : '0'
          this.company_setup.is_invoice_unit_price_visible_in_irn = this.company_setup.is_invoice_unit_price_visible_in_irn ? this.company_setup.is_invoice_unit_price_visible_in_irn : '0'
          this.company_setup.is_invoice_upload_file_visible_in_irn = this.company_setup.is_invoice_upload_file_visible_in_irn ? this.company_setup.is_invoice_upload_file_visible_in_irn : '0'

          this.company_setup.custom_name_for_usable_qty = this.company_setup.custom_name_for_usable_qty ? this.company_setup.custom_name_for_usable_qty : 'Usable QTY'
          this.company_setup.custom_name_for_error_size = this.company_setup.custom_name_for_error_size ? this.company_setup.custom_name_for_error_size : 'Error Size'
          this.company_setup.is_total_qty_inwarded_visible = this.company_setup.is_total_qty_inwarded_visible ? this.company_setup.is_total_qty_inwarded_visible : '0'
          this.company_setup.is_acceptable_rejection_percentage_visible = this.company_setup.is_acceptable_rejection_percentage_visible ? this.company_setup.is_acceptable_rejection_percentage_visible : '0'
this.company_setup.is_rejection_percentage_visible = this.company_setup.is_rejection_percentage_visible ? this.company_setup.is_rejection_percentage_visible : '0'

          this.company_setup.add_invoice_requested_by_custom_name = this.company_setup.add_invoice_requested_by_custom_name ? this.company_setup.add_invoice_requested_by_custom_name : 'GRN Approver Name'
          this.company_setup.in_invoice_grn_no_custom_name = this.company_setup.in_invoice_grn_no_custom_name ? this.company_setup.in_invoice_grn_no_custom_name : 'GRN/QA No'
          this.company_setup.in_invoice_irn_no_custom_name = this.company_setup.in_invoice_irn_no_custom_name ? this.company_setup.in_invoice_irn_no_custom_name : 'IRN No'
          this.company_setup.in_invoice_grn_date_custom_name = this.company_setup.in_invoice_grn_date_custom_name ? this.company_setup.in_invoice_grn_date_custom_name : 'GRN Date'
         this.company_setup.custome_name_for_total_discounted_amount_in_po_module=this.company_setup.custome_name_for_total_discounted_amount_in_po_module?this.company_setup.custome_name_for_total_discounted_amount_in_po_module:'Total Discounted Amount';
          this.company_setup.hide_invoice_tds_related_fields = this.company_setup.hide_invoice_tds_related_fields ? this.company_setup.hide_invoice_tds_related_fields : '0';
          this.company_setup.is_delivery_cc_visible = this.company_setup.is_delivery_cc_visible ? this.company_setup.is_delivery_cc_visible : '0';
          this.company_setup.is_delivery_cc_visible_po = this.company_setup.is_delivery_cc_visible_po ? this.company_setup.is_delivery_cc_visible_po : '0';
          this.company_setup.in_invoice_date_format = this.company_setup.in_invoice_date_format ? this.company_setup.in_invoice_date_format : "dd-mm-yyyy";
          this.company_setup.in_add_invoice_rejected_qty_hidden = false;
          this.company_setup.add_invoice_columnList = this.company_setup.add_invoice_columnList ? this.company_setup.add_invoice_columnList : []
          this.company_setup.comma_separate_currency_code = this.company_setup.comma_separate_currency_code ? this.company_setup.comma_separate_currency_code : 'IND';
          this.company_setup.is_enable_comma_separate_price = this.company_setup.is_enable_comma_separate_price ? this.company_setup.is_enable_comma_separate_price : '0';
          this.company_setup.allowed_digits_after_decimal = this.company_setup.allowed_digits_after_decimal ? this.company_setup.allowed_digits_after_decimal : '2';
          this.company_setup.enable_free_quantity_in_po = this.company_setup.enable_free_quantity_in_po ? this.company_setup.enable_free_quantity_in_po : '0';
          this.company_setup.enable_accepted_free_quantity_in_invoice = this.company_setup.enable_accepted_free_quantity_in_invoice ? this.company_setup.enable_accepted_free_quantity_in_invoice : '0';
          this.company_setup.enable_free_quantity_in_direct_invoice = this.company_setup.enable_free_quantity_in_direct_invoice ? this.company_setup.enable_free_quantity_in_direct_invoice : '0';
          this.company_setup.is_budget_selection_at_item_level_in_product_table = this.company_setup.is_budget_selection_at_item_level_in_product_table ? this.company_setup.is_budget_selection_at_item_level_in_product_table  :'0';
          this.company_setup.enable_unplanned_checkbox_for_line_items = this.company_setup.enable_unplanned_checkbox_for_line_items ? this.company_setup.enable_unplanned_checkbox_for_line_items : '0';
          this.company_setup.select_pr_list = this.company_setup.select_pr_list ? this.company_setup.select_pr_list : [];

          
          if (this.company_setup.add_invoice_columnList.length > 0) {
            this.company_setup.in_add_invoice_rejected_qty_hidden = this.company_setup.add_invoice_columnList.some((v) => { return v.id == 'rejected_qty' && v.isVisible });
          }
        }
        else {
          this.toasterService.pop('error', "Error", data.message);
        }
        this.isProcessing=false;
        this.apiCall();
      }, error => {
        this.isProcessing=false;
        this.toasterService.pop("error", "Error", "Something Went Wrong");

      }
    )
  }
  apiCall() {

    switch (this.tableDetails.id) {
      case 'recurring_invoicereport':
        this.commonVariableList.columnList = globalVariables.recurring_invoiceVariableList.columnList;
        this.commonVariableList.items = this.tableDetails.data.invoice_items ? this.tableDetails.data.invoice_items : [];
        if (this.commonVariableList.items) {
          for (let i of this.commonVariableList.items) {

            i.total_required_qty = this.webService.convertNaN(i.total_required_qty, this.company_setup.allowed_digits_after_decimal)
            i.total_required_qty = parseFloat(i.total_required_qty)
            i.total_required_qty = this.webService.convertNaN(i.total_required_qty, this.company_setup.allowed_digits_after_decimal)


            i.invoice_unit_price = this.webService.convertNaN(i.invoice_unit_price, this.company_setup.allowed_digits_after_decimal)
            i.invoice_unit_price = parseFloat(i.invoice_unit_price)
            i.invoice_unit_price = this.webService.convertNaN(i.invoice_unit_price)
            i.unplanned_cost = i.unplanned_cost == '1';

            i.invoice_qty = this.webService.convertNaN(i.invoice_qty, this.company_setup.allowed_digits_after_decimal)
            i.invoice_qty = parseFloat(i.invoice_qty)
            i.invoice_qty = this.webService.convertNaN(i.invoice_qty, this.company_setup.allowed_digits_after_decimal)

            i.product_unit_price = this.webService.convertNaN(i.product_unit_price, this.company_setup.allowed_digits_after_decimal)
            i.product_unit_price = parseFloat(i.product_unit_price)
            i.product_unit_price = this.webService.convertNaN(i.product_unit_price, this.company_setup.allowed_digits_after_decimal)

            i.hsn_other_tax = i.hsn_other_tax ? i.hsn_other_tax : ''
            i.hsn_ugst = i.hsn_ugst ? i.hsn_ugst : ''
            i.hsn_cgst = i.hsn_cgst ? i.hsn_cgst : ''
            i.hsn_sgst = i.hsn_sgst ? i.hsn_sgst : ''
            i.hsn_igst = i.hsn_igst ? i.hsn_igst : ''



            // invoice
            i.invoice_cess = this.webService.convertNaN(i.invoice_cess)
            i.invoice_other_tax = this.webService.convertNaN(i.invoice_other_tax)
            i.invoice_ugst = this.webService.convertNaN(i.invoice_ugst)
            i.invoice_cgst = this.webService.convertNaN(i.invoice_cgst)
            i.invoice_sgst = this.webService.convertNaN(i.invoice_sgst)
            i.invoice_igst = this.webService.convertNaN(i.invoice_igst)

            // paid
            i.hsn_cess = parseFloat(i.paid_cess) <= 0 ? '' : i.hsn_cess;
            i.hsn_other_tax = parseFloat(i.paid_other_tax) <= 0 ? '' : i.hsn_other_tax;
            i.hsn_ugst = parseFloat(i.paid_ugst) <= 0 ? '' : i.hsn_ugst;
            i.hsn_cgst = parseFloat(i.paid_cgst) <= 0 ? '' : i.hsn_cgst;
            i.hsn_sgst = parseFloat(i.paid_sgst) <= 0 ? '' : i.hsn_sgst;
            i.hsn_igst = parseFloat(i.paid_igst) <= 0 ? '' : i.hsn_igst;

            // invoice
            i.hsn_cess = parseFloat(i.invoice_cess) <= 0 ? '' : i.hsn_cess;
            i.hsn_other_tax = parseFloat(i.invoice_other_tax) <= 0 ? '' : i.hsn_other_tax;
            i.hsn_ugst = parseFloat(i.invoice_ugst) <= 0 ? '' : i.hsn_ugst;
            i.hsn_cgst = parseFloat(i.invoice_cgst) <= 0 ? '' : i.hsn_cgst;
            i.hsn_sgst = parseFloat(i.invoice_sgst) <= 0 ? '' : i.hsn_sgst;
            i.hsn_igst = parseFloat(i.invoice_igst) <= 0 ? '' : i.hsn_igst;


          }
        }
        let is_direct1: any = '0';
        is_direct1 = this.tableDetails.data.is_direct ? this.tableDetails.data.is_direct : '0'
        let is_good1:boolean = this.commonVariableList.items.some((v) => {
          return v.product_type == 'services'
        })
        if (this.commonVariableList.columnList) {

          for (let i of this.commonVariableList.columnList) {

            if (i.value == 'conversion_unit_price' && this.tableDetails.data.is_different_document_currency == '0') {
              i.display = "FC (PO) Unit Price"
              i.is_view = false;
            }
            if (i.value == 'conversion_unit_price' && this.tableDetails.data.is_different_document_currency == '1') {
              i.display = "FC (PO) Unit Price" + "(" + this.tableDetails.data.currency_code + ")";
              i.is_view = true;
            }

            if (i.value == 'conversion_paid_price' && this.tableDetails.data.is_different_document_currency == '0') {
              i.display = "FC Paid Price Per Unit"
              i.is_view = false;
            }
            if (i.value == 'conversion_paid_price' && this.tableDetails.data.is_different_document_currency == '1') {
              i.display = "FC Paid Price Per Unit" + "(" + this.tableDetails.data.currency_code + ")";
              i.is_view = true;
            }

            if (i.value == 'conversion_invoice_price' && this.tableDetails.data.is_different_document_currency == '0') {
              i.display = "FC Invoice Unit Price"
              i.is_view = false;
            }
            if (i.value == 'conversion_invoice_price' && this.tableDetails.data.is_different_document_currency == '1') {
              i.display = "FC Invoice Unit Price" + "(" + this.tableDetails.data.currency_code + ")";
              i.is_view = true;
            }



            if (i.value == 'product_catalog_id' && this.company_setup.product_catalog_id == '1') {
              i.is_view = true;
            }
            if (i.value == 'product_catalog_id' && this.company_setup.product_catalog_id == '0') {
              i.is_view = false;
            }



          }
        }
        this.makeData();

        break;

      case 'invoicereport':
        this.commonVariableList.columnList = globalVariables.invoiceVariableList.columnList;
        this.commonVariableList.items = this.tableDetails.data.invoice_items ? this.tableDetails.data.invoice_items : [];
        if (this.tableDetails.data && this.tableDetails.data.is_invoice_scanned == '1' && this.commonVariableList.items.length > 1) {
          this.commonVariableList.items.sort((a: any, b: any) => this.compareInvoiceItemsByOcrLineIndex(a, b));
        }
        if (this.commonVariableList.items) {
          for (let i of this.commonVariableList.items) {

            i.po_qty = this.webService.convertNaN(i.po_qty, this.company_setup.allowed_digits_after_decimal)
            i.po_qty = parseFloat(i.po_qty)
            i.po_qty = this.webService.convertNaN(i.po_qty, this.company_setup.allowed_digits_after_decimal)


            i.total_required_qty = this.webService.convertNaN(i.total_required_qty)
            i.total_required_qty = parseFloat(i.total_required_qty)
            i.total_required_qty = this.webService.convertNaN(i.total_required_qty)



            i.rejected_qty = this.webService.convertNaN(i.rejected_qty, this.company_setup.allowed_digits_after_decimal)
            i.rejected_qty = parseFloat(i.rejected_qty)
            i.rejected_qty = this.webService.convertNaN(i.rejected_qty, this.company_setup.allowed_digits_after_decimal)



            i.po_unit_price = this.webService.convertNaN(i.po_unit_price, this.company_setup.allowed_digits_after_decimal)
            i.po_unit_price = parseFloat(i.po_unit_price)
            i.po_unit_price = this.webService.convertNaN(i.po_unit_price, this.company_setup.allowed_digits_after_decimal)


            i.invoice_unit_price = this.webService.convertNaN(i.invoice_unit_price, this.company_setup.allowed_digits_after_decimal)
            i.invoice_unit_price = parseFloat(i.invoice_unit_price)
            i.invoice_unit_price = this.webService.convertNaN(i.invoice_unit_price)
            i.unplanned_cost = i.unplanned_cost == '1';

            i.invoice_qty = this.webService.convertNaN(i.invoice_qty, this.company_setup.allowed_digits_after_decimal)
            i.invoice_qty = parseFloat(i.invoice_qty)
            i.invoice_qty = this.webService.convertNaN(i.invoice_qty, this.company_setup.allowed_digits_after_decimal)

            i.accepted_qty = this.webService.convertNaN(i.accepted_qty, this.company_setup.allowed_digits_after_decimal)
            i.accepted_qty = parseFloat(i.accepted_qty)
            i.accepted_qty = this.webService.convertNaN(i.accepted_qty, this.company_setup.allowed_digits_after_decimal)

            i.free_qty = this.webService.convertNaN(i.free_qty)
            i.free_qty = parseFloat(i.free_qty)
            i.free_qty = this.webService.convertNaN(i.free_qty)

            i.product_unit_price = this.webService.convertNaN(i.product_unit_price)
            i.product_unit_price = parseFloat(i.product_unit_price)
            i.product_unit_price = this.webService.convertNaN(i.product_unit_price, this.company_setup.allowed_digits_after_decimal)

            i.hsn_other_tax = i.hsn_other_tax ? i.hsn_other_tax : ''
            i.hsn_ugst = i.hsn_ugst ? i.hsn_ugst : ''
            i.hsn_cgst = i.hsn_cgst ? i.hsn_cgst : ''
            i.hsn_sgst = i.hsn_sgst ? i.hsn_sgst : ''
            i.hsn_igst = i.hsn_igst ? i.hsn_igst : ''

            // paid
            i.paid_cess = this.webService.convertNaN(i.paid_cess)
            i.paid_other_tax = this.webService.convertNaN(i.paid_other_tax)
            i.paid_ugst = this.webService.convertNaN(i.paid_ugst)
            i.paid_cgst = this.webService.convertNaN(i.paid_cgst)
            i.paid_sgst = this.webService.convertNaN(i.paid_sgst)
            i.paid_igst = this.webService.convertNaN(i.paid_igst)

            // invoice
            i.invoice_cess = this.webService.convertNaN(i.invoice_cess)
            i.invoice_other_tax = this.webService.convertNaN(i.invoice_other_tax)
            i.invoice_ugst = this.webService.convertNaN(i.invoice_ugst)
            i.invoice_cgst = this.webService.convertNaN(i.invoice_cgst)
            i.invoice_sgst = this.webService.convertNaN(i.invoice_sgst)
            i.invoice_igst = this.webService.convertNaN(i.invoice_igst)

            // paid
            i.hsn_cess = parseFloat(i.paid_cess) <= 0 ? '' : i.hsn_cess;
            i.hsn_other_tax = parseFloat(i.paid_other_tax) <= 0 ? '' : i.hsn_other_tax;
            i.hsn_ugst = parseFloat(i.paid_ugst) <= 0 ? '' : i.hsn_ugst;
            i.hsn_cgst = parseFloat(i.paid_cgst) <= 0 ? '' : i.hsn_cgst;
            i.hsn_sgst = parseFloat(i.paid_sgst) <= 0 ? '' : i.hsn_sgst;
            i.hsn_igst = parseFloat(i.paid_igst) <= 0 ? '' : i.hsn_igst;

            // invoice
            i.hsn_cess = parseFloat(i.invoice_cess) <= 0 ? '' : i.hsn_cess;
            i.hsn_other_tax = parseFloat(i.invoice_other_tax) <= 0 ? '' : i.hsn_other_tax;
            i.hsn_ugst = parseFloat(i.invoice_ugst) <= 0 ? '' : i.hsn_ugst;
            i.hsn_cgst = parseFloat(i.invoice_cgst) <= 0 ? '' : i.hsn_cgst;
            i.hsn_sgst = parseFloat(i.invoice_sgst) <= 0 ? '' : i.hsn_sgst;
            i.hsn_igst = parseFloat(i.invoice_igst) <= 0 ? '' : i.hsn_igst;


          }
        }
        let is_direct: any = '0';
        is_direct = this.tableDetails.data.is_direct ? this.tableDetails.data.is_direct : '0'
        let is_good:boolean = this.commonVariableList.items.some((v) => {
          return v.product_type == 'services'
        })
        if (this.commonVariableList.columnList) {

          for (let i of this.commonVariableList.columnList) {
            if (i.value == 'tds_section_name' && !is_good) {
              i.is_view = false;
            }
            if (i.value == 'tds_section_name' && is_good) {
              i.is_view = true;
            }

            if (i.value == 'tds_rate' && !is_good) {
              i.is_view = false;
            }
            if (i.value == 'tds_rate' && is_good) {
              i.is_view = true;
            }

            if (i.value == 'po_no' && this.tableDetails.data.is_multi_grn_invoice == '0') {
              i.display = "PO No"
              i.is_view = false;
            }
            if (i.value == 'po_no' && this.tableDetails.data.is_multi_grn_invoice == '1') {
              i.display = "PO No";
              i.is_view = true;
            }

            if (i.value == 'po_date' && this.tableDetails.data.is_multi_grn_invoice == '0') {
              i.display = "PO Date"
              i.is_view = false;
            }
            if (i.value == 'po_date' && this.tableDetails.data.is_multi_grn_invoice == '1') {
              i.display = "PO Date";
              i.is_view = true;
            }

            if (i.value == 'irn_cs_id' && this.tableDetails.data.is_multi_grn_invoice == '0') {
              i.display =this.company_setup.in_invoice_irn_no_custom_name;
              i.is_view = false;
            }
            if (i.value == 'irn_cs_id' && this.tableDetails.data.is_multi_grn_invoice == '1') {
              i.display = this.company_setup.in_invoice_irn_no_custom_name;
              i.is_view = true;
            }

            if (i.value == 'irn_date' && this.tableDetails.data.is_multi_grn_invoice == '0') {
              i.display = "IRN Date"
              i.is_view = false;
            }
            if (i.value == 'irn_date' && this.tableDetails.data.is_multi_grn_invoice == '1') {
              i.display = "IRN Date";
              i.is_view = true;
            }

            if (i.value == 'grn_cs_id' && this.tableDetails.data.is_multi_grn_invoice == '0') {
              i.display = this.company_setup.in_invoice_grn_no_custom_name
              i.is_view = false;
            }
            if (i.value == 'grn_cs_id' && this.tableDetails.data.is_multi_grn_invoice == '1') {
              i.display =this.company_setup.in_invoice_grn_no_custom_name
              i.is_view = true;
            }

            if (i.value == 'grn_date' && this.tableDetails.data.is_multi_grn_invoice == '0') {
              i.display = this.company_setup.grn_date_custom_name
              i.is_view = false;
            }
            if (i.value == 'grn_date' && this.tableDetails.data.is_multi_grn_invoice == '1') {
              i.display = this.company_setup.grn_date_custom_name;
              i.is_view = true;
            }



            if (i.value == 'conversion_unit_price' && this.tableDetails.data.is_different_document_currency == '0') {
              i.display = "FC (PO) Unit Price"
              i.is_view = false;
            }
            if (i.value == 'conversion_unit_price' && this.tableDetails.data.is_different_document_currency == '1') {
              i.display = "FC (PO) Unit Price" + "(" + this.tableDetails.data.currency_code + ")";
              i.is_view = true;
            }

            if (i.value == 'conversion_paid_price' && this.tableDetails.data.is_different_document_currency == '0') {
              i.display = "FC Paid Price Per Unit"
              i.is_view = false;
            }
            if (i.value == 'conversion_paid_price' && this.tableDetails.data.is_different_document_currency == '1') {
              i.display = "FC Paid Price Per Unit" + "(" + this.tableDetails.data.currency_code + ")";
              i.is_view = true;
            }

            if (i.value == 'conversion_invoice_price' && this.tableDetails.data.is_different_document_currency == '0') {
              i.display = "FC Invoice Unit Price"
              i.is_view = false;
            }
            if (i.value == 'conversion_invoice_price' && this.tableDetails.data.is_different_document_currency == '1') {
              i.display = "FC Invoice Unit Price" + "(" + this.tableDetails.data.currency_code + ")";
              i.is_view = true;
            }

            if (i.value == 'total_required_qty' && this.tableDetails.data.is_direct == '1') {
              i.is_view = false;
            }
            if (i.value == 'total_required_qty' && this.tableDetails.data.is_direct == '0') {
              i.is_view = true;
            }


            if (i.value == 'product_catalog_id' && this.company_setup.product_catalog_id == '1') {
              i.is_view = true;
            }
            if (i.value == 'product_catalog_id' && this.company_setup.product_catalog_id == '0') {
              i.is_view = false;
            }

            if (i.value == 'rejected_qty' && is_direct == '0') {
              // i.is_view = true;
              if (this.company_setup.in_add_invoice_rejected_qty_hidden=='1') {
                i.is_view = false;
              }
              if (this.company_setup.in_add_invoice_rejected_qty_hidden=='0') {
                i.is_view = true;
              }
            }

            if (i.value == 'rejected_qty' && is_direct == '1') {

              if (this.company_setup.is_rejected_qty_visible_in_direct_invoice=='1') {
                i.is_view = true;
              }
              if (this.company_setup.is_rejected_qty_visible_in_direct_invoice=='0') {
                i.is_view = false;
              }
            }

            if (i.value == 'total_required_qty' && is_direct == '0') {
              i.is_view = true;
            }
            if (i.value == 'total_required_qty' && is_direct == '1') {
              i.is_view = false;
            }
            let arr = ["tds_section_name", "tds_rate"]
            if (arr.includes(i.value) && this.company_setup.hide_invoice_tds_related_fields == '1') {
              i.is_view = false;
            }

            // Free Qty columns — direct invoice vs PO-based invoice use separate column definitions.
            if (i.value == 'unplanned_cost' && this.company_setup.enable_unplanned_checkbox_for_line_items == '1') {
              i.is_view = true;
            }
            if (i.value == 'unplanned_cost' && this.company_setup.enable_unplanned_checkbox_for_line_items == '0') {
              i.is_view = false;
            }
            if (i.value == 'free_qty') {
              if(is_direct == '1' && this.company_setup.enable_free_quantity_in_direct_invoice == '1'){
                i.display = 'Free Qty';
                i.is_view = true;
              } else if(is_direct != '1' && this.company_setup.enable_accepted_free_quantity_in_invoice == '1'){
                i.display = 'Accepted Free Qty';
                i.is_view = true;
              } else {
                i.is_view = false;
              }
            } 
          }
        }
        this.makeData();

        break;
        case 'dcnotereport':
          this.tableDetails.data.items.forEach((item)=>{
   
            item.gst_checked = item.check_gst_status == '1' ? true : false;
          })
          globalVariables.dcNoteVariableList.columnList.forEach((val)=>{
             if(val.value == 'gst_checked'){
              val.is_view = this.tableDetails.data.show_gst == '1'? true :false
             }
          })
          this.commonVariableList.columnList = globalVariables.dcNoteVariableList.columnList;
          this.commonVariableList.items = this.tableDetails.data.items ? this.tableDetails.data.items : [];
          if (this.commonVariableList.items) {
            for (let d of this.commonVariableList.items) {
              d.hsn_other_tax = d.hsn_other_tax ? d.hsn_other_tax : '0'
              d.hsn_ugst = d.hsn_ugst ? d.hsn_ugst : '0'
              d.hsn_cgst = d.hsn_cgst ? d.hsn_cgst : '0'
              d.hsn_sgst = d.hsn_sgst ? d.hsn_sgst : '0'
              d.hsn_igst = d.hsn_igst ? d.hsn_igst : '0'

              d.cess = this.webService.convertNaN(d.cess)
              d.other_tax = this.webService.convertNaN(d.other_tax)
              d.ugst = this.webService.convertNaN(d.ugst)
              d.cgst = this.webService.convertNaN(d.cgst)
              d.sgst = this.webService.convertNaN(d.sgst)
              d.igst = this.webService.convertNaN(d.igst)

              d.cess = parseFloat(d.cess)
              d.other_tax = parseFloat(d.other_tax)
              d.ugst = parseFloat(d.ugst)
              d.cgst = parseFloat(d.cgst)
              d.sgst = parseFloat(d.sgst)
              d.igst = parseFloat(d.igst)


              d.cgst=this.webService.convertNaN(d.cgst)
              d.sgst=this.webService.convertNaN(d.sgst)
              d.igst=this.webService.convertNaN(d.igst)
              d.ugst=this.webService.convertNaN(d.ugst)
              d.cess=this.webService.convertNaN(d.cess)
              d.other_tax=this.webService.convertNaN(d.other_tax)


              d.hsn_cess = parseFloat(d.cess) <= 0 ? '' : d.hsn_cess;
              d.hsn_other_tax = parseFloat(d.other_tax) <= 0 ? '' : d.hsn_other_tax;
              d.hsn_ugst = parseFloat(d.ugst) <= 0 ? '' : d.hsn_ugst;
              d.hsn_cgst = parseFloat(d.cgst) <= 0 ? '' : d.hsn_cgst;
              d.hsn_sgst = parseFloat(d.sgst) <= 0 ? '' : d.hsn_sgst;
              d.hsn_igst = parseFloat(d.igst) <= 0 ? '' : d.hsn_igst;
            }
          }
          this.makeData();

          break;
      case 'grnreport':
        this.commonVariableList.columnList = globalVariables.grnVariableList.columnList;
        this.commonVariableList.items = this.tableDetails.data.grn_items ? this.tableDetails.data.grn_items : [];
        console.log("this.commonVariableList.items",this.commonVariableList.items)
        this.company_setup.grn_add_button_custom_name = this.company_setup.grn_add_button_custom_name ? this.company_setup.grn_add_button_custom_name : 'Add GRN'
        this.company_setup.grn_date_custom_name = this.company_setup.grn_date_custom_name ? this.company_setup.grn_date_custom_name : 'GRN Date'
        this.company_setup.grn_no_custom_name = this.company_setup.grn_no_custom_name ? this.company_setup.grn_no_custom_name : 'GRN No'

        this.company_setup.barcode_code = this.company_setup.barcode_code ? this.company_setup.barcode_code : '0'
        this.company_setup.qr_code = this.company_setup.qr_code ? this.company_setup.qr_code : '0'
        this.company_setup.send_damage_mail = this.company_setup.send_damage_mail ? this.company_setup.send_damage_mail : '0';
        this.company_setup.grn_checked_type = this.company_setup.grn_checked_type ? this.company_setup.grn_checked_type : '0';
        this.company_setup.grn_sample_size = this.company_setup.grn_sample_size ? this.company_setup.grn_sample_size : '0';
        this.company_setup.grn_error_size = this.company_setup.grn_error_size ? this.company_setup.grn_error_size : '0';
        this.company_setup.grn_is_closed = this.company_setup.grn_is_closed ? this.company_setup.grn_is_closed : '0';
        this.company_setup.grn_product_owned_type = this.company_setup.grn_product_owned_type ? this.company_setup.grn_product_owned_type : '0';

        this.company_setup.grn_unit_type_visible = this.company_setup.grn_unit_type_visible ? this.company_setup.grn_unit_type_visible : '0';

        this.company_setup.grn_action_visible = this.company_setup.grn_action_visible ? this.company_setup.grn_action_visible : '0';
        this.company_setup.grn_subcategory_visible = this.company_setup.grn_subcategory_visible ? this.company_setup.grn_subcategory_visible : '0';
        this.company_setup.grn_category_visible = this.company_setup.grn_category_visible ? this.company_setup.grn_category_visible : '0';
        this.company_setup.grn_catalog_visible = this.company_setup.grn_catalog_visible ? this.company_setup.grn_catalog_visible : '0';
        this.company_setup.grn_requested_by_visible = this.company_setup.grn_requested_by_visible ? this.company_setup.grn_requested_by_visible : '0';

        let is_closed: boolean = true;
        let send_damage_mail: boolean = true;
        let is_rack_dimension: boolean = false;
        let is_bar_qr_visible: boolean = false;

        is_bar_qr_visible = this.tableDetails.data.is_fully_approved=='1'?true:false;
        is_closed = this.commonVariableList.items.some((v) => {
          return v.is_closed
        })
        send_damage_mail = this.commonVariableList.items.some((v) => {
          return v.send_damage_mail
        })

        is_rack_dimension = this.commonVariableList.items.some((v) => {
          return v.rack_dimension_name != '' && v.rack_dimension_name != undefined && v.rack_dimension_name != null
        })
        if (this.commonVariableList.items) {
          for (let i of this.commonVariableList.items) {

            i.accepted_qty = this.webService.convertNaN(i.accepted_qty, this.company_setup.allowed_digits_after_decimal)
            i.accepted_qty = parseFloat(i.accepted_qty)
            i.accepted_qty = this.webService.convertNaN(i.accepted_qty, this.company_setup.allowed_digits_after_decimal)


            i.rejected_qty = this.webService.convertNaN(i.rejected_qty, this.company_setup.allowed_digits_after_decimal)
            i.rejected_qty =parseFloat(i.rejected_qty)
            i.rejected_qty = this.webService.convertNaN(i.rejected_qty, this.company_setup.allowed_digits_after_decimal)


            i.qty = this.webService.convertNaN(i.qty, this.company_setup.allowed_digits_after_decimal)
            i.qty = parseFloat(i.qty)
            i.qty = this.webService.convertNaN(i.qty, this.company_setup.allowed_digits_after_decimal)


            i.total_required_qty = this.webService.convertNaN(i.total_required_qty, this.company_setup.allowed_digits_after_decimal)
            i.total_required_qty = parseFloat(i.total_required_qty)
            i.total_required_qty = this.webService.convertNaN(i.total_required_qty, this.company_setup.allowed_digits_after_decimal)


            i.received_qty = this.webService.convertNaN(i.received_qty, this.company_setup.allowed_digits_after_decimal)
            i.received_qty = parseFloat(i.received_qty)
            i.received_qty = this.webService.convertNaN(i.received_qty, this.company_setup.allowed_digits_after_decimal)


            i.current_required_qty = this.webService.convertNaN(i.current_required_qty, this.company_setup.allowed_digits_after_decimal)
            i.current_required_qty = parseFloat(i.current_required_qty)
            i.current_required_qty = this.webService.convertNaN(i.current_required_qty, this.company_setup.allowed_digits_after_decimal)
            i.product_owned_type_name = '';

            switch (i.product_owned_type) {
              case '1':
                i.product_owned_type_name = 'New Owned';
                break;
              case '2':
                i.product_owned_type_name = 'New Leased';
                break;
              case '3':
                i.product_owned_type_name = 'Old Owned';
                break;
              case '4':
                i.product_owned_type_name = 'Old Leased';
                break;
              case '5':
                i.product_owned_type_name = 'Consignement';
                break;
              case '6':
                i.product_owned_type_name = 'Damaged but Usable';
                break;
              case '7':
                i.product_owned_type_name = 'Damaged and Not Usable';
                break;
              default:
                i.product_owned_type_name = '';
            }

            i.grn_checked_type_name = '';

            switch (i.grn_checked_type) {
              case '1':
                i.grn_checked_type_name = 'Sample Checked';
                break;
              case '2':
                i.grn_checked_type_name = 'Entire Quantity Checked';
                break;
              case '3':
                i.grn_checked_type_name = 'None';
                break;
                case '0':
                  i.grn_checked_type_name = 'None';
                  break;
              default:
                i.grn_checked_type_name = '';
            }
          }
        }


        if (this.commonVariableList.columnList) {
          for (let i of this.commonVariableList.columnList) {
            if (i.value == 'grn_no') {
              i.display = this.company_setup.grn_no_custom_name;
            }
            if (i.value == 'grn_date') {
              i.display = this.company_setup.grn_date_custom_name;
            }

            if (i.value == 'error_size') {
              i.display = this.company_setup.custom_name_for_error_size;
            }
            if (i.value == 'damaged_qty') {
              i.display = this.company_setup.custom_name_for_usable_qty;
            }

            if (i.value == 'category_name' && this.company_setup.grn_category_visible == '1') {
              i.is_view = true;
            }
            if (i.value == 'category_name' && this.company_setup.grn_category_visible == '0') {
              i.is_view = false;
            }
            if (i.value == 'subcategory_name' && this.company_setup.grn_subcategory_visible == '1') {
              i.is_view = true;
            }
            if (i.value == 'subcategory_name' && this.company_setup.grn_subcategory_visible == '0') {
              i.is_view = false;
            }


            if (i.value == 'unit_type_name' && this.company_setup.grn_unit_type_visible == '1') {
              i.is_view = true;
            }
            if (i.value == 'unit_type_name' && this.company_setup.grn_unit_type_visible == '0') {
              i.is_view = false;
            }


            if (i.value == 'product_catalog_id' && this.company_setup.product_catalog_id == '1' && this.company_setup.grn_catalog_visible == '1') {
              i.is_view = true;
            }
            if (i.value == 'product_catalog_id' && this.company_setup.product_catalog_id == '0' && this.company_setup.grn_catalog_visible == '0') {
              i.is_view = false;
            }
            if (i.value == 'rack_dimension_name' && is_rack_dimension) {
              i.is_view = true;
            }
            if (i.value == 'rack_dimension_name' && !is_rack_dimension) {
              i.is_view = false;
            }
            if (i.value == 'grn_checked_type_name' && this.company_setup.grn_checked_type == '0') {
              i.is_view = false;
            }
            if (i.value == 'sample_size' && this.company_setup.grn_sample_size == '0') {
              i.is_view = false;
            }

            if (i.value == 'error_size' && this.company_setup.grn_error_size == '0') {
              i.is_view = false;
            }

            if (i.value == 'product_owned_type_name' && this.company_setup.grn_product_owned_type == '0') {
              i.is_view = false;
            }
            if (i.value == 'is_closed' && is_closed) {
              i.is_view = true;
            }
            if (i.value == 'send_damage_mail' && send_damage_mail) {
              i.is_view = true;
            }
            if (i.value == 'qrcode_file_url' && this.company_setup.qr_code == '0') {
              i.is_view = false;
            }
            if (i.value == 'barcode_file_url' && this.company_setup.barcode_code == '0') {
              i.is_view = false;
            }

            if (i.value == 'qrcode_file_url' && this.company_setup.qr_code == '1') {
              i.is_view=true;
              if(!is_bar_qr_visible)
              {
                i.is_view=false;
              }
            }
            if (i.value == 'barcode_file_url' && this.company_setup.barcode_code == '1') {
              i.is_view=true;
              if(!is_bar_qr_visible)
              {
                i.is_view=false;
              }
            }

            if (i.value == 'invoice_qty' && this.company_setup.is_invoice_qty_visible_in_irn == '0') {
              i.is_view = false;
            }
            if (i.value == 'invoice_qty'  && this.company_setup.is_invoice_qty_visible_in_irn == '1') {
              i.is_view = true;
            }

            if (i.value == 'invoice_unit_price'  && this.company_setup.is_invoice_unit_price_visible_in_irn == '0') {
              i.is_view = false;
            }
            if (i.value == 'invoice_unit_price'  && this.company_setup.is_invoice_unit_price_visible_in_irn == '1') {
              i.is_view = true;
            }

            if (i.value == 'total_inward_qty'  && this.company_setup.is_total_qty_inwarded_visible == '0') {
              i.is_view = false;
            }
            if (i.value == 'total_inward_qty'  && this.company_setup.is_total_qty_inwarded_visible == '1') {
              i.is_view = true;
            }

            if (i.value == 'rejection_percentage'  && this.company_setup.is_rejection_percentage_visible == '0') {
              i.is_view = false;
            }
            if (i.value == 'rejection_percentage'  && this.company_setup.is_rejection_percentage_visible == '1') {
              i.is_view = true;
            }

            if (i.value == 'acceptable_rejection_percentage'  && this.company_setup.is_acceptable_rejection_percentage_visible == '0') {
              i.is_view = false;
            }
            if (i.value == 'acceptable_rejection_percentage'  && this.company_setup.is_acceptable_rejection_percentage_visible == '1') {
              i.is_view = true;
            }

          }
        }
        this.makeData();

        break;
      case 'irnreport':
        this.commonVariableList.columnList = globalVariables.irnVariableList.columnList
        this.commonVariableList.items = this.tableDetails.data.irn_items ? this.tableDetails.data.irn_items : [];
        let is_damaged: boolean = true;
        this.company_setup.irn_unit_type_visible = this.company_setup.irn_unit_type_visible ? this.company_setup.irn_unit_type_visible : '0';
        this.company_setup.irn_add_button_custom_name = this.company_setup.irn_add_button_custom_name ? this.company_setup.irn_add_button_custom_name : 'Add IRN'
        this.company_setup.irn_date_custom_name = this.company_setup.irn_date_custom_name ? this.company_setup.irn_date_custom_name : 'IRN Date'
        this.company_setup.irn_no_custom_name = this.company_setup.irn_no_custom_name ? this.company_setup.irn_no_custom_name : 'IRN No'

        this.company_setup.irn_action_visible = this.company_setup.irn_action_visible ? this.company_setup.irn_action_visible : '0';
        this.company_setup.irn_damaged_visible = this.company_setup.irn_damaged_visible ? this.company_setup.irn_damaged_visible : '0';
        this.company_setup.irn_subcategory_visible = this.company_setup.irn_subcategory_visible ? this.company_setup.irn_subcategory_visible : '0';
        this.company_setup.irn_category_visible = this.company_setup.irn_category_visible ? this.company_setup.irn_category_visible : '0';
        this.company_setup.irn_catalog_visible = this.company_setup.irn_catalog_visible ? this.company_setup.irn_catalog_visible : '0';
        this.company_setup.irn_requested_by_visible = this.company_setup.irn_requested_by_visible ? this.company_setup.irn_requested_by_visible : '0';


        if (this.commonVariableList.items) {
          for (let i of this.commonVariableList.items) {

            i.qty=this.webService.convertNaN(i.qty, this.company_setup.allowed_digits_after_decimal)
            i.qty=parseFloat(i.qty)
            i.qty=this.webService.convertNaN(i.qty, this.company_setup.allowed_digits_after_decimal)

            i.total_required_qty=this.webService.convertNaN(i.total_required_qty, this.company_setup.allowed_digits_after_decimal)
            i.total_required_qty=parseFloat(i.total_required_qty)
            i.total_required_qty=this.webService.convertNaN(i.total_required_qty, this.company_setup.allowed_digits_after_decimal)

            i.current_required_qty=this.webService.convertNaN(i.current_required_qty, this.company_setup.allowed_digits_after_decimal)
            i.current_required_qty=parseFloat(i.current_required_qty)
            i.current_required_qty=this.webService.convertNaN(i.current_required_qty, this.company_setup.allowed_digits_after_decimal)

            i.received_qty = this.webService.convertNaN(i.received_qty, this.company_setup.allowed_digits_after_decimal)
            i.received_qty = parseFloat(i.received_qty)
            i.received_qty = this.webService.convertNaN(i.received_qty, this.company_setup.allowed_digits_after_decimal)

            i.accepted_qty=this.webService.convertNaN(i.accepted_qty, this.company_setup.allowed_digits_after_decimal)
            i.accepted_qty=parseFloat(i.accepted_qty)
            i.accepted_qty=this.webService.convertNaN(i.accepted_qty, this.company_setup.allowed_digits_after_decimal)


            i.rejected_qty=this.webService.convertNaN(i.rejected_qty, this.company_setup.allowed_digits_after_decimal)
            i.rejected_qty=parseFloat(i.rejected_qty)
            i.rejected_qty=this.webService.convertNaN(i.rejected_qty, this.company_setup.allowed_digits_after_decimal)



          }
        }

        if (this.commonVariableList.columnList) {
          for (let i of this.commonVariableList.columnList) {

            if (i.value == 'irn_no') {
              i.display = this.company_setup.irn_no_custom_name;
            }
            if (i.value == 'irn_date') {
              i.display = this.company_setup.irn_date_custom_name;
            }


            if (i.value == 'category_name' && this.company_setup.irn_category_visible == '1') {
              i.is_view = true;
            }
            if (i.value == 'category_name' && this.company_setup.irn_category_visible == '0') {
              i.is_view = false;
            }
            if (i.value == 'subcategory_name' && this.company_setup.irn_subcategory_visible == '1') {
              i.is_view = true;
            }
            if (i.value == 'subcategory_name' && this.company_setup.irn_subcategory_visible == '0') {
              i.is_view = false;
            }


            if (i.value == 'unit_type_name' && this.company_setup.irn_unit_type_visible == '1') {
              i.is_view = true;
            }
            if (i.value == 'unit_type_name' && this.company_setup.irn_unit_type_visible == '0') {
              i.is_view = false;
            }


            if (i.value == 'product_catalog_id' && this.company_setup.product_catalog_id == '1' && this.company_setup.irn_catalog_visible == '1') {
              i.is_view = true;
            }
            if (i.value == 'product_catalog_id' && this.company_setup.product_catalog_id == '0' && this.company_setup.irn_catalog_visible == '0') {
              i.is_view = false;
            }
            if (i.value == 'accepted_qty' && this.company_setup.merge_grn_irn == '1') {
              i.is_view = true;
            }
            if (i.value == 'accepted_qty' && this.company_setup.merge_grn_irn == '0') {
              i.is_view = false;
            }

            if (i.value == 'rejected_qty' && this.company_setup.merge_grn_irn == '1') {
              i.is_view = true;
            }
            if (i.value == 'rejected_qty' && this.company_setup.merge_grn_irn == '0') {
              i.is_view = false;
            }

            if (i.value == 'rejected_reason' && this.company_setup.merge_grn_irn == '1') {
              i.is_view = true;
            }
            if (i.value == 'rejected_reason' && this.company_setup.merge_grn_irn == '0') {
              i.is_view = false;
            }
            if (i.value == 'is_damaged' && !is_damaged && this.company_setup.irn_damaged_visible == '0') {
              i.is_view = false;
            }
            if (i.value == 'is_damaged' && is_damaged && this.company_setup.irn_damaged_visible == '1') {
              i.is_view = true;
            }

            if (i.value == 'invoice_qty' && this.company_setup.is_invoice_qty_visible_in_irn == '0') {
              i.is_view = false;
            }
            if (i.value == 'invoice_qty'  && this.company_setup.is_invoice_qty_visible_in_irn == '1') {
              i.is_view = true;
            }

            if (i.value == 'invoice_unit_price'  && this.company_setup.is_invoice_unit_price_visible_in_irn == '0') {
              i.is_view = false;
            }
            if (i.value == 'invoice_unit_price'  && this.company_setup.is_invoice_unit_price_visible_in_irn == '1') {
              i.is_view = true;
            }



          }
        }
        this.makeData();

        break;
      case 'poreport':
        let url:any='/'+window.location.href.substring(window.location.href.lastIndexOf('/') + 1);
        let is_new_item_visible:boolean=this.webService.getMenuByUrl(url).id=="38"?false:true;

        this.commonVariableList.columnList = globalVariables.poVariableList.columnList;
        this.commonVariableList.items = this.tableDetails.data.po_items ? this.tableDetails.data.po_items : [];
        this.company_setup.is_catalog_id_visible = false;
        let is_direct_items:boolean=false;
        let is_amend_visible:boolean=false;
        this.company_setup.po_item_columnList = this.company_setup.po_item_columnList ? this.company_setup.po_item_columnList : []
        if (this.company_setup.po_item_columnList.length > 0) {
          this.company_setup.is_catalog_id_visible = this.company_setup.po_item_columnList.some((v) => { return v.id == 'catalog_id' && v.isVisible })
        }

        if(!is_new_item_visible)
        {
          this.commonVariableList.items=this.commonVariableList.items.filter((v)=>{return v.is_direct=='0'});
        }
        if (this.commonVariableList.items) {
          for (let d of this.commonVariableList.items) {
            if(d.is_direct=='0')
            {
              d.revised_po_date='';
            }
            if(!is_new_item_visible && d.is_direct=='0')
            {
              d.is_highlighted_row=false;
            }
            if(is_new_item_visible && d.is_direct=='1')
            {
              d.is_highlighted_row=true;
            }
            d.product_qty = d.product_qty ? parseFloat(d.product_qty) : '0';

            d.lead_time = this.webService.convertNaN(d.lead_time) ? this.webService.convertNaN(d.lead_time) : '0';
            d.current_stock = this.webService.convertNaN(d.current_stock) ? this.webService.convertNaN(d.current_stock) : '0';
            d.average_daily_consumption = this.webService.convertNaN(d.average_daily_consumption) ? this.webService.convertNaN(d.average_daily_consumption) : '0';
            d.inventory_in_hand = this.webService.convertNaN(d.inventory_in_hand) ? this.webService.convertNaN(d.inventory_in_hand) : '0';
            d.procured_days = this.webService.convertNaN(d.procured_days) ? this.webService.convertNaN(d.procured_days) : '0';
            d.moq = this.webService.convertNaN(d.moq) ? this.webService.convertNaN(d.moq) : '0';
            d.item_qty = this.webService.convertNaN(d.item_qty) ? this.webService.convertNaN(d.item_qty) : '0';

            // d.product_qty = parseFloat(d.product_qty) ? parseFloat(d.product_qty) : '0';

            d.lead_time = parseFloat(d.lead_time) ? parseFloat(d.lead_time) : '0';
            d.current_stock = parseFloat(d.current_stock) ? parseFloat(d.current_stock) : '0';
            d.average_daily_consumption = parseFloat(d.average_daily_consumption) ? parseFloat(d.average_daily_consumption) : '0';
            d.inventory_in_hand = parseFloat(d.inventory_in_hand) ? parseFloat(d.inventory_in_hand) : '0';
            d.procured_days = parseFloat(d.procured_days) ? parseFloat(d.procured_days) : '0';
            d.moq = parseFloat(d.moq) ? parseFloat(d.moq) : '0';
            d.item_qty = parseFloat(d.item_qty) ? parseFloat(d.item_qty) : '0';


            d.unit_price = d.product_unit_price ? parseFloat(d.product_unit_price) : '0';
            // d.product_qty = this.webService.convertNaN(d.product_qty) ? this.webService.convertNaN(d.product_qty) : '0';

            d.lead_time = this.webService.convertNaN(d.lead_time) ? this.webService.convertNaN(d.lead_time) : '0';
            d.current_stock = this.webService.convertNaN(d.current_stock) ? this.webService.convertNaN(d.current_stock) : '0';
            d.average_daily_consumption = this.webService.convertNaN(d.average_daily_consumption) ? this.webService.convertNaN(d.average_daily_consumption) : '0';
            d.inventory_in_hand = this.webService.convertNaN(d.inventory_in_hand) ? this.webService.convertNaN(d.inventory_in_hand) : '0';
            d.procured_days = this.webService.convertNaN(d.procured_days) ? this.webService.convertNaN(d.procured_days) : '0';
            d.moq = this.webService.convertNaN(d.moq) ? this.webService.convertNaN(d.moq) : '0';
            d.item_qty = this.webService.convertNaN(d.item_qty) ? this.webService.convertNaN(d.item_qty) : '0';

            // d.product_qty=this.webService.convertNaN(d.product_qty)
            // d.product_qty=parseFloat(d.product_qty)
            // d.product_qty=this.webService.convertNaN(d.product_qty)

            d.product_unit_price = d.unit_price;

            



            d.hsn_other_tax = d.hsn_other_tax ? d.hsn_other_tax : '0'
            d.hsn_ugst = d.hsn_ugst ? d.hsn_ugst : '0'
            d.hsn_cgst = d.hsn_cgst ? d.hsn_cgst : '0'
            d.hsn_sgst = d.hsn_sgst ? d.hsn_sgst : '0'
            d.hsn_igst = d.hsn_igst ? d.hsn_igst : '0'

            d.cess = this.webService.convertNaN(d.cess)
            d.other_tax = this.webService.convertNaN(d.other_tax)
            d.ugst = this.webService.convertNaN(d.ugst)
            d.cgst = this.webService.convertNaN(d.cgst)
            d.sgst = this.webService.convertNaN(d.sgst)
            d.igst = this.webService.convertNaN(d.igst)

            d.cess = parseFloat(d.cess)
            d.other_tax = parseFloat(d.other_tax)
            d.ugst = parseFloat(d.ugst)
            d.cgst = parseFloat(d.cgst)
            d.sgst = parseFloat(d.sgst)
            d.igst = parseFloat(d.igst)


            d.cgst=this.webService.convertNaN(d.cgst)
            d.sgst=this.webService.convertNaN(d.sgst)
            d.igst=this.webService.convertNaN(d.igst)
            d.ugst=this.webService.convertNaN(d.ugst)
            d.cess=this.webService.convertNaN(d.cess)
            d.other_tax=this.webService.convertNaN(d.other_tax)


            d.hsn_cess = parseFloat(d.cess) <= 0 ? '' : d.hsn_cess;
            d.hsn_other_tax = parseFloat(d.other_tax) <= 0 ? '' : d.hsn_other_tax;
            d.hsn_ugst = parseFloat(d.ugst) <= 0 ? '' : d.hsn_ugst;
            d.hsn_cgst = parseFloat(d.cgst) <= 0 ? '' : d.hsn_cgst;
            d.hsn_sgst = parseFloat(d.sgst) <= 0 ? '' : d.hsn_sgst;
            d.hsn_igst = parseFloat(d.igst) <= 0 ? '' : d.hsn_igst;
            // d.service_end_date = this.webService.makeWrongDateEmpty(d.service_end_date)
            // d.service_start_date = this.webService.makeWrongDateEmpty(d.service_start_date)
            // d.product_required_by = this.webService.makeWrongDateEmpty(d.product_required_by)
            // d.service_end_date = this.webService.formatDateAccordingToSetup(d.service_end_date,this.company_setup.in_invoice_date_format)
            // d.service_start_date = this.webService.formatDateAccordingToSetup(d.service_start_date,this.company_setup.in_invoice_date_format)
            d.service_end_date = this.webService.formatDateAccordingToSetup(this.webService.getLocalDate(d.service_end_date),this.company_setup.in_invoice_date_format);
            d.service_start_date = this.webService.formatDateAccordingToSetup(this.webService.getLocalDate(d.service_start_date), this.company_setup.in_invoice_date_format);
            d.product_required_by = this.webService.formatDateAccordingToSetup(this.webService.getLocalDate(d.product_required_by),this.company_setup.in_invoice_date_format)
            d.amend_po_status=d.amend_po_status?d.amend_po_status:'',
            d.haz = d.haz == "1" ? 'Yes': 'No'
            d.delivery_cc=d.delivery_cc?d.delivery_cc:''
          }
        }

        let is_not_service: boolean = true;
        let is_goods: boolean = true;
        let is_logistic: boolean = true;
        let is_all_service: boolean = true;
        let is_not_discount: boolean = false;
        let isServiceProduct:boolean = false;
        is_direct_items=this.commonVariableList.items.some((v) => {
          return v.is_direct =="1"
        })
        is_amend_visible=this.commonVariableList.items.some((v) => {
          return v.amend_po_status !='' && v.amend_po_status !=undefined
        })
        is_not_discount = this.commonVariableList.items.every((v) => {
          return v.discount_unit_price == '0'
        })
        is_logistic = this.commonVariableList.items.some((v) => {
          return v.is_logistic
        })
        is_goods = this.commonVariableList.items.every((v) => {
          return v.product_type.toLowerCase() == 'goods'
        })

        is_not_service = this.commonVariableList.items.every((v) => {
          return v.service_start_date == '' && v.service_end_date == ''
        })
        is_all_service = this.commonVariableList.items.every((v) => {
          return v.product_type.toLowerCase() == 'services'
        })
        isServiceProduct = this.commonVariableList.items.some((v) => {
          return v.product_type.toLowerCase() == 'services'
        })
        let revised_po_date_visible:boolean=this.commonVariableList.items.some((v) => {
          return v.revised_po_date !='' && v.revised_po_date!=undefined && v.revised_po_date!=null
        })
        this.tableDetails.data.is_custom_ship_to_location = this.tableDetails.data.is_custom_ship_to_location ? this.tableDetails.data.is_custom_ship_to_location : '0';
        this.tableDetails.data.custom_ship_to_location = this.tableDetails.data.custom_ship_to_location ? this.tableDetails.data.custom_ship_to_location : '0';


        if (this.commonVariableList.columnList) {
          for (let i of this.commonVariableList.columnList) {
            if (i.value == 'ship_to_location' && this.tableDetails.data.is_custom_ship_to_location == '0') {
              i.is_view = false;
            }
            if (i.value == 'ship_to_location' && this.tableDetails.data.is_custom_ship_to_location == '1') {
              i.is_view = false;
            }

            if (i.value == 'open_po_qty' && this.company_setup.is_show_open_qty_button_visible_at_raise_time == '1') {
              i.is_view = true;
            }
            if (i.value == 'open_po_qty' && this.company_setup.is_show_open_qty_button_visible_at_raise_time == '0') {
              i.is_view = false;
            }


            if (i.value == 'open_grn_qty' && this.company_setup.is_show_open_qty_button_visible_at_raise_time == '1') {
              i.is_view = true;
            }
            if (i.value == 'open_grn_qty' && this.company_setup.is_show_open_qty_button_visible_at_raise_time == '0') {
              i.is_view = false;
            }
   // amend po start

   if(i.value == 'revised_po_date' &&!is_new_item_visible)
            {
              i.is_view=false
            }
            if(i.value == 'revised_po_date' &&is_new_item_visible)
            {
              i.is_view=true;
              if(!is_direct_items)
              {
                i.is_view=false;
              }

              if(!revised_po_date_visible)
              {
                i.is_view=false;
              }
            }
            // amend po start

            if (i.value == 'amend_po_status' && is_amend_visible &&is_new_item_visible) {
              i.is_view = true;
            }
            if (i.value == 'amend_po_status' && !is_amend_visible &&!is_new_item_visible) {
              i.is_view = false;
            }

            if (i.value == 'amend_po_qty' && is_amend_visible &&is_new_item_visible) {
              i.is_view = true;
            }
            if (i.value == 'amend_po_qty' && !is_amend_visible &&!is_new_item_visible) {
              i.is_view = false;
            }


            if (i.value == 'amend_date' && is_amend_visible &&is_new_item_visible) {
              i.is_view = true;
            }
            if (i.value == 'amend_date' && !is_amend_visible &&!is_new_item_visible) {
              i.is_view = false;
            }

            if (i.value == 'amend_added_by' && is_amend_visible &&is_new_item_visible) {
              i.is_view = true;
            }
            if (i.value == 'amend_added_by' && !is_amend_visible &&!is_new_item_visible) {
              i.is_view = false;
            }
            // amend po closed

            if (i.value == 'average_daily_consumption') {
              i.display = this.company_setup.average_consumption_frequency_name;
            }

            if (i.value == 'current_stock' && this.company_setup.is_current_stock_po_visible == '1') {
              i.is_view = true;
            }
            if (i.value == 'current_stock' && this.company_setup.is_current_stock_po_visible == '0') {
              i.is_view = false;
            }

            if (i.value == 'current_stock' && this.tableDetails.data.is_direct=='1') {
              // i.is_view = false;
            }

            if (i.value == 'average_daily_consumption' && this.company_setup.is_average_daily_consumption_po_visible == '1') {
              i.is_view = true;
            }
            if (i.value == 'average_daily_consumption' && this.company_setup.is_average_daily_consumption_po_visible == '0') {
              i.is_view = false;
            }

            if (i.value == 'average_daily_consumption' && this.tableDetails.data.is_direct=='1') {
              // i.is_view = false;
            }

            if (i.value == 'inventory_in_hand' && this.company_setup.is_inventory_in_hand_po_visible == '1') {
              i.is_view = true;
            }
            if (i.value == 'inventory_in_hand' && this.company_setup.is_inventory_in_hand_po_visible == '0') {
              i.is_view = false;
            }
 if (i.value == 'inventory_in_hand' && this.tableDetails.data.is_direct=='1') {
              // i.is_view = false;
            }
            if (i.value == 'inventory_in_hand') {
              i.display = this.company_setup.pr_inventory_in_hand_name;
            }
            if (i.value == 'procured_days') {
              i.display = this.company_setup.pr_procured_days_name;
            }
            if (i.value == 'lead_time' && this.company_setup.is_lead_time_po_visible == '1') {
              i.is_view = true;
            }
            if (i.value == 'lead_time' && this.company_setup.is_lead_time_po_visible == '0') {
              i.is_view = false;
            }
            if (i.value == 'lead_time' && this.tableDetails.data.is_direct=='1') {
              // i.is_view = false;
            }

            if (i.value == 'procured_days' && this.company_setup.is_procured_days_po_visible == '1') {
              i.is_view = true;
            }
            if (i.value == 'procured_days' && this.company_setup.is_procured_days_po_visible == '0') {
              i.is_view = false;
            }

            if (i.value == 'procured_days' && this.tableDetails.data.is_direct=='1') {
              // i.is_view = false;
            }
            if (i.value == 'discount_unit_price' && this.company_setup.is_discount_applicable_in_po == '1') {
              i.is_view = true;
              if (is_not_discount) {
                if (i.value == 'discount_unit_price') {
                  i.is_view = false;
                }
              }
            }
            if (i.value == 'discount_unit_price' && this.company_setup.is_discount_applicable_in_po == '0') {
              i.is_view = false;
            }
            if (i.value == 'discounted_unit_price' && this.company_setup.is_discount_applicable_in_po == '1') {
              i.is_view = true;
              if (is_not_discount) {
                if (i.value == 'discounted_unit_price') {
                  i.is_view = false;
                }
              }
            }
            if (i.value == 'discounted_unit_price' && this.company_setup.is_discount_applicable_in_po == '0') {
              i.is_view = false;
            }

            if (i.value == 'discount_amount' && this.company_setup.is_discount_applicable_in_po == '1') {
              i.is_view = true;
              if (is_not_discount) {
                if (i.value == 'discount_amount') {
                  i.is_view = false;
                }
              }
            }
            if (i.value == 'discount_amount' && this.company_setup.is_discount_applicable_in_po == '0') {
              i.is_view = false;
            }

            if (i.value == 'discounted_amount' && this.company_setup.is_discount_applicable_in_po == '1') {
              i.is_view = true;
              if (is_not_discount) {
                if (i.value == 'discounted_amount') {
                  i.is_view = false;
                }
              }
            }
            if (i.value == 'discounted_amount' && this.company_setup.is_discount_applicable_in_po == '0') {
              i.is_view = false;
            }

            if (i.value == 'discount_percentage' && this.company_setup.is_discount_applicable_in_po == '1') {
              i.is_view = true;
              if (is_not_discount) {
                if (i.value == 'discount_percentage') {
                  i.is_view = false;
                }
              }
            }
            if (i.value == 'discount_percentage' && this.company_setup.is_discount_applicable_in_po == '0') {
              i.is_view = false;
            }



            if (i.value == 'product_catalog_id' && this.company_setup.is_catalog_id_visible && this.company_setup.product_catalog_id_one == '1') {
              i.is_view = true;
            }
            if (i.value == 'product_catalog_id' && (!this.company_setup.is_catalog_id_visible || this.company_setup.product_catalog_id_one == '0')) {
              i.is_view = false;
            }

            if (i.value == 'conversion_unit_price' && this.tableDetails.data.is_different_document_currency == '1') {
              i.is_view = true;
              i.display = "Unit price (" + this.tableDetails.data.currency_code + ")"
            }
            if (i.value == 'conversion_unit_price' && this.tableDetails.data.is_different_document_currency == '0') {
              i.is_view = false;
              i.display = "Unit price";

            }

            if (i.value == 'is_logistic' && !is_logistic) {
              i.is_view = false;
            }

            if ((i.value == 'service_start_date' || i.value == 'service_end_date' || i.value == 'total_duration') &&  this.company_setup.is_service_start_end_date_visible == '0') {
              i.is_view = false;
            }

            if ((i.value == 'service_start_date' || i.value == 'service_end_date' || i.value == 'total_duration') &&  this.company_setup.is_service_start_end_date_visible == '0') {
              i.is_view = false;
            }

            if ((i.value == 'service_start_date' || i.value == 'service_end_date' || i.value == 'total_duration') && (isServiceProduct && this.company_setup.is_service_start_end_date_visible == '1')) {
              i.is_view = true;
            }
            if (i.value == 'product_required_by') {
              i.display = this.company_setup.custome_name_for_required_by_in_po_pr_module;
            }
            if(i.value == 'discounted_amount'){
              i.display = this.company_setup.custome_name_for_total_discounted_amount_in_po_module;
            }
            if (i.value == 'delivery_cc_name' && this.company_setup.is_delivery_cc_visible_po == '1') {
              i.is_view = true;
            }
          }
        }


        this.makeData();

        break;
      case 'mpreport':
        this.commonVariableList.columnList = globalVariables.mpVariableList.columnList;
        this.commonVariableList.items = this.tableDetails.data.mp_items ? this.tableDetails.data.mp_items : [];

        if (this.commonVariableList.columnList) {
          for (let i of this.commonVariableList.columnList) {
            if (i.value == 'product_catalog_id' && this.company_setup.product_catalog_id == '1') {
              i.is_view = true;
            }
            if (i.value == 'product_catalog_id' && this.company_setup.product_catalog_id == '0') {
              i.is_view = false;
            }
          }
        }
        this.makeData();

        break;
      case 'sireport':
        this.commonVariableList.columnList = globalVariables.siVariableList.columnList;
        this.commonVariableList.items = this.tableDetails.data.si_items ? this.tableDetails.data.si_items : [];

        if (this.commonVariableList.columnList) {
          for (let i of this.commonVariableList.columnList) {
            if (i.value == 'product_catalog_id' && this.company_setup.product_catalog_id == '1') {
              i.is_view = true;
            }
            if (i.value == 'product_catalog_id' && this.company_setup.product_catalog_id == '0') {
              i.is_view = false;
            }
          }
        }
        this.makeData();

        break;
      case 'prreport':
        this.commonVariableList.columnList = globalVariables.prVariableList.columnList;
        this.commonVariableList.items = this.tableDetails.data.pr_items ? this.tableDetails.data.pr_items : [];
        if (this.commonVariableList.items) {
          for (let d of this.commonVariableList.items) { 
            d.is_closed_item_wise = d.is_closed_item_wise == '0'?false:true;
            d.delivery_cc_name = d.delivery_cc_name ? d.delivery_cc_name : '';
            d.product_required_by = this.webService.formatDateAccordingToSetup(this.webService.getLocalDate(d.product_required_by),this.company_setup.in_invoice_date_format)
            d.product_qty = d.product_qty ? parseFloat(d.product_qty) : '0';
            d.unit_price = d.unit_price ? parseFloat(d.unit_price) : '0';

            if(d.delivery_cc_name=='' || d.delivery_cc_name==null || d.delivery_cc_name==undefined) {
              d.delivery_cc_name = d.delivery_cc_location ? d.delivery_cc_location : '';
              d.delivery_cc_name = d.delivery_cc_code ? d.delivery_cc_name + " (" + d.delivery_cc_code + ")" : d.delivery_cc_name;
            }
            d.vendor= d.vendor ? d.vendor : [],
            d.ven_list = Array.isArray(d.vendor) ? d.vendor.map(v => v.vendor_address) : [];           
          }
        }
        this.company_setup.is_pr_unit_price_visible = this.company_setup.is_pr_unit_price_visible ? this.company_setup.is_pr_unit_price_visible : '0'
        this.company_setup.is_current_stock_visible = this.company_setup.is_current_stock_visible ? this.company_setup.is_current_stock_visible : '0'
        this.company_setup.is_average_daily_consumption_visible = this.company_setup.is_average_daily_consumption_visible ? this.company_setup.is_average_daily_consumption_visible : '0'
        this.company_setup.is_inventory_in_hand_visible = this.company_setup.is_inventory_in_hand_visible ? this.company_setup.is_inventory_in_hand_visible : '0'
        this.company_setup.is_lead_time_visible = this.company_setup.is_lead_time_visible ? this.company_setup.is_lead_time_visible : '0'
        this.company_setup.is_procured_days_visible = this.company_setup.is_procured_days_visible ? this.company_setup.is_procured_days_visible : '0'
        this.company_setup.is_moq_visible = this.company_setup.is_moq_visible ? this.company_setup.is_moq_visible : '0'
        this.company_setup.average_consumption_frequency_name = this.company_setup.average_consumption_frequency_name ? this.company_setup.average_consumption_frequency_name : 'Average Monthly Consumption'
        this.company_setup.in_pr_editable_boq_unit_or_boq_item_qty=this.company_setup.in_pr_editable_boq_unit_or_boq_item_qty?this.company_setup.in_pr_editable_boq_unit_or_boq_item_qty:'boq_item_qty'
        this.company_setup.custome_name_for_required_by_in_po_pr_module=this.company_setup.custome_name_for_required_by_in_po_pr_module?this.company_setup.custome_name_for_required_by_in_po_pr_module:'Required By';
        this.company_setup.is_catalog_id_visible = false;
        this.company_setup.pr_item_columnList = this.company_setup.pr_item_columnList ? this.company_setup.pr_item_columnList : []
        if (this.company_setup.pr_item_columnList.length > 0) {
          this.company_setup.is_catalog_id_visible = this.company_setup.pr_item_columnList.some((v) => { return v.id == 'catalog_id' && v.isVisible })
        }
        if (this.commonVariableList.columnList) {
          for (let i of this.commonVariableList.columnList) {
            if(i.value=='already_raised_qty' && this.company_setup.in_pr_editable_boq_unit_or_boq_item_qty=='boq_item_qty' && this.tableDetails.data.is_boq=='1')
            {
              i.is_view=true;
            }
            if(i.value=='already_raised_qty' && (this.company_setup.in_pr_editable_boq_unit_or_boq_item_qty!='boq_item_qty' || this.tableDetails.data.is_boq!='1'))
            {
              i.is_view=false;
            }
            if (i.value == 'inventory_in_hand') {
              i.display = this.company_setup.pr_inventory_in_hand_name;
            }
            if (i.value == 'procured_days') {
              i.display = this.company_setup.pr_procured_days_name;
            }

            if (i.value == 'product_catalog_id' && this.company_setup.is_catalog_id_visible && this.company_setup.product_catalog_id == '1') {
              i.is_view = true;
            }
            if (i.value == 'product_catalog_id' && (!this.company_setup.is_catalog_id_visible || this.company_setup.product_catalog_id == '0')) {
              i.is_view = false;
            }

            if (i.value == 'average_daily_consumption') {
              i.display = this.company_setup.average_consumption_frequency_name;
            }

            if (i.value == 'unit_price' && this.company_setup.is_pr_unit_price_visible == '0') {
              i.is_view = false;
            }

            if (i.value == 'current_stock' && this.company_setup.is_current_stock_visible == '1') {
              i.is_view = true;
            }
            if (i.value == 'shortfall_quantity') {
              i.display = this.getPrColumnName('shortfall_quantity', 'Shortfall Quantity');
              i.is_view = this.is_pr_column_visible('shortfall_quantity', false);
            }

            if (i.value == 'average_daily_consumption' && this.company_setup.is_average_daily_consumption_visible == '1') {
              i.is_view = true;
            }
            if (i.value == 'inventory_in_hand' && this.company_setup.is_inventory_in_hand_visible == '1') {
              i.is_view = true;
            }
            if (i.value == 'lead_time' && this.company_setup.is_lead_time_visible == '1') {
              i.is_view = true;
            }
            if (i.value == 'procured_days' && this.company_setup.is_procured_days_visible == '1') {
              i.is_view = true;
            }
            if (i.value == 'moq' && this.company_setup.is_moq_visible == '1') {
              i.is_view = true;
            }
            if (i.value == 'product_required_by') {
              i.display = this.company_setup.custome_name_for_required_by_in_po_pr_module;
            }
            if (i.value == 'delivery_cc_name' && this.company_setup.is_delivery_cc_visible == '1') {
              i.is_view = true;
            }
            if (i.value == 'subcategory_name' && this.company_setup.visible_product_category_subcategory_in_pr == '1') {
              i.is_view = true;
            }
            if (i.value == 'subcategory_name' && this.company_setup.visible_product_category_subcategory_in_pr == '0') {
              i.is_view = false;
            }
            if (i.value == 'category_name' && this.company_setup.visible_product_category_subcategory_in_pr == '1') {
              i.is_view = true;
            }
            if (i.value == 'category_name' && this.company_setup.visible_product_category_subcategory_in_pr == '0') {
              i.is_view = false;
            }
            if (i.value == 'project_name' && this.company_setup.is_budget_selection_at_item_level_in_product_table == '1') {
              i.is_view = true;
            }
            if (i.value == 'project_name' && this.company_setup.is_budget_selection_at_item_level_in_product_table == '0') {
              i.is_view = false;
            }
            if (i.value == 'task_name' && this.company_setup.is_budget_selection_at_item_level_in_product_table == '1') {
              i.is_view = true;
            }
            if (i.value == 'task_name' && this.company_setup.is_budget_selection_at_item_level_in_product_table == '0') {
              i.is_view = false;
            }
            if (i.value == 'make') {
              if(this.is_pr_column_visible('is_make', false)){
                i.is_view = true;
              }else{
                i.is_view = false
              }
              i.display = this.getPrColumnName('is_make', 'Make');

            }
            if (i.value == 'model') {
              if(this.is_pr_column_visible('is_model', false)){
                i.is_view = true;
              }else{
                i.is_view = false
              }
              i.display = this.getPrColumnName('is_model', 'Model');

            }
            if (i.value == 'additional_field1') {
              if(this.is_pr_column_visible('additional_field1', false)){
                i.is_view = true;
              }else{
                i.is_view = false
              }
              i.display = this.getPrColumnName('additional_field1', 'Additional Field 1');

            }
            if (i.value == 'additional_field2') {
              if(this.is_pr_column_visible('additional_field2', false)){
                i.is_view = true;
              }else{
                i.is_view = false
              }
              i.display = this.getPrColumnName('additional_field2', 'Additional Field 2');

            }
            if (i.value == 'pr_product_no') {
              if(this.is_pr_column_visible('pr_product_no', false)){
                i.is_view = true;
              }else{
                i.is_view = false
              }
              i.display = this.getPrColumnName('pr_product_no', 'Product No');
            }
            if (i.value == 'pr_product_l') {
              if(this.is_pr_column_visible('pr_product_l', false)){
                i.is_view = true;
              }else{
                i.is_view = false
              }
              i.display = this.getPrColumnName('pr_product_l', 'Product L');
            }
            if (i.value == 'pr_product_b') {
              if(this.is_pr_column_visible('pr_product_b', false)){
                i.is_view = true;
              }else{
                i.is_view = false
              }
              i.display = this.getPrColumnName('pr_product_b', 'Product B');
            }
            if (i.value == 'pr_product_d') {
              if(this.is_pr_column_visible('pr_product_d', false)){
                i.is_view = true;
              }else{
                i.is_view = false
              }
              i.display = this.getPrColumnName('pr_product_d', 'Product D');
            }

          }
        }

        this.makeData();

        break;

      case 'irreport':
        this.commonVariableList.columnList = globalVariables.irVariableList.columnList;
        this.commonVariableList.items = this.tableDetails.data.ir_items ? this.tableDetails.data.ir_items : [];

        this.company_setup.is_ir_unit_price_visible = this.company_setup.is_ir_unit_price_visible ? this.company_setup.is_ir_unit_price_visible : '0'
        this.company_setup.is_current_stock_visible_in_ir = this.company_setup.is_current_stock_visible_in_ir ? this.company_setup.is_current_stock_visible_in_ir : '0'
        this.company_setup.is_average_daily_consumption_visible_in_ir = this.company_setup.is_average_daily_consumption_visible_in_ir ? this.company_setup.is_average_daily_consumption_visible_in_ir : '0'
        this.company_setup.is_inventory_in_hand_visible_in_ir = this.company_setup.is_inventory_in_hand_visible ? this.company_setup.is_inventory_in_hand_visible_in_ir : '0'
        this.company_setup.is_lead_time_visible_in_ir = this.company_setup.is_lead_time_visible_in_ir ? this.company_setup.is_lead_time_visible_in_ir : '0'
        this.company_setup.is_procured_days_visible_in_ir = this.company_setup.is_procured_days_visible_in_ir ? this.company_setup.is_procured_days_visible_in_ir : '0'
        this.company_setup.is_moq_visible_in_ir = this.company_setup.is_moq_visible_in_ir ? this.company_setup.is_moq_visible_in_ir : '0'
        this.company_setup.average_consumption_frequency_name_in_ir = this.company_setup.average_consumption_frequency_name_in_ir ? this.company_setup.average_consumption_frequency_name_in_ir : 'Average Monthly Consumption'

        this.company_setup.is_catalog_id_visible = false;
        this.company_setup.ir_item_columnList = this.company_setup.ir_item_columnList ? this.company_setup.ir_item_columnList : []
        if (this.company_setup.ir_item_columnList.length > 0) {
          this.company_setup.is_catalog_id_visible = this.company_setup.ir_item_columnList.some((v) => { return v.id == 'catalog_id' && v.isVisible })
        }
        if (this.commonVariableList.columnList) {
          for (let i of this.commonVariableList.columnList) {
            if (i.value == 'inventory_in_hand') {
              i.display = this.company_setup.ir_inventory_in_hand_name;
            }
            if (i.value == 'procured_days') {
              i.display = this.company_setup.ir_procured_days_name;
            }

            if (i.value == 'product_catalog_id' && this.company_setup.is_catalog_id_visible && this.company_setup.product_catalog_id == '1') {
              i.is_view = true;
            }
            if (i.value == 'product_catalog_id' && (!this.company_setup.is_catalog_id_visible || this.company_setup.product_catalog_id == '0')) {
              i.is_view = false;
            }

            if (i.value == 'average_daily_consumption') {
              i.display = this.company_setup.average_consumption_frequency_name_in_ir;
            }

            if (i.value == 'unit_price' && this.company_setup.is_ir_unit_price_visible == '0') {
              i.is_view = false;
            }

            if (i.value == 'current_stock' && this.company_setup.is_current_stock_visible_in_ir == '1') {
              i.is_view = true;
            }

            if (i.value == 'average_daily_consumption' && this.company_setup.is_average_daily_consumption_visible_in_ir == '1') {
              i.is_view = true;
            }
            if (i.value == 'inventory_in_hand' && this.company_setup.is_inventory_in_hand_visible_in_ir == '1') {
              i.is_view = true;
            }
            if (i.value == 'lead_time' && this.company_setup.is_lead_time_visible_in_ir == '1') {
              i.is_view = true;
            }
            if (i.value == 'procured_days' && this.company_setup.is_procured_days_visible_in_ir == '1') {
              i.is_view = true;
            }
            if (i.value == 'moq' && this.company_setup.is_moq_visible_in_ir == '1') {
              i.is_view = true;
            }

          }
        }
        if(this.commonVariableList.items)
        {
          for(let x of this.commonVariableList.items)
          {
            x.lead_time = this.webService.convertNaN(parseFloat(this.webService.convertNaN(x.lead_time))) ?  this.webService.convertNaN(parseFloat(this.webService.convertNaN(x.lead_time))) : '0';
            x.current_stock =  this.webService.convertNaN(parseFloat(this.webService.convertNaN(x.current_stock))) ?  this.webService.convertNaN(parseFloat(this.webService.convertNaN(x.current_stock))) : '0';
            // x.ir_location = x.ir_location_noinit ? x.ir_location_noinit : '0';
            x.average_daily_consumption =  this.webService.convertNaN(parseFloat(this.webService.convertNaN(x.average_daily_consumption))) ?  this.webService.convertNaN(parseFloat(this.webService.convertNaN(x.average_daily_consumption))) : '0';
            x.inventory_in_hand =  this.webService.convertNaN(parseFloat(this.webService.convertNaN(x.inventory_in_hand))) ?  this.webService.convertNaN(parseFloat(this.webService.convertNaN(x.inventory_in_hand))) : '0';
            x.procured_days =  this.webService.convertNaN(parseFloat(this.webService.convertNaN(x.procured_days))) ?  this.webService.convertNaN(parseFloat(this.webService.convertNaN(x.procured_days))) : '0';
            x.moq =  this.webService.convertNaN(parseFloat(this.webService.convertNaN(x.moq))) ?  this.webService.convertNaN(parseFloat(this.webService.convertNaN(x.moq))) : '0';

            x.item_qty =  this.webService.convertNaN(parseFloat(this.webService.convertNaN(x.item_qty))) ?  this.webService.convertNaN(parseFloat(this.webService.convertNaN(x.item_qty))) : '0';


          }
        }
        this.makeData();

        break;

      case 'mprreport':
        this.commonVariableList.columnList = globalVariables.mprVariableList.columnList;
        this.commonVariableList.items = this.tableDetails.data.mpr_items ? this.tableDetails.data.mpr_items : [];

        this.company_setup.is_mpr_sku_visible = this.company_setup.is_mpr_sku_visible ? this.company_setup.is_mpr_sku_visible : '0';
        this.company_setup.is_mpr_unit_type_visible = this.company_setup.is_mpr_unit_type_visible ? this.company_setup.is_mpr_unit_type_visible : '0';
        this.company_setup.is_mpr_my_boq_visible = this.company_setup.is_mpr_my_boq_visible ? this.company_setup.is_mpr_my_boq_visible : '0';
        this.company_setup.is_mpr_buffer_stock_visible = this.company_setup.is_mpr_buffer_stock_visible ? this.company_setup.is_mpr_buffer_stock_visible : '0';


        if (this.commonVariableList.columnList) {
          for (let i of this.commonVariableList.columnList) {
            if (i.value == 'product_catalog_id' && this.company_setup.product_catalog_id == '1') {
              i.is_view = true;
            }
            if (i.value == 'product_catalog_id' && this.company_setup.product_catalog_id == '0') {
              i.is_view = false;
            }

            if (i.value == 'productcode' && this.company_setup.is_mpr_sku_visible == '1') {
              i.is_view = true;
            }
            if (i.value == 'productcode' && this.company_setup.is_mpr_sku_visible == '0') {
              i.is_view = false;
            }

            if (i.value == 'unit_type_name' && this.company_setup.is_mpr_unit_type_visible == '0') {
              i.is_view = false;
            }

            if (i.value == 'unit_type_name' && this.company_setup.is_mpr_unit_type_visible == '1') {
              i.is_view = true;
            }

            if (i.value == 'is_this_my_boq' && this.company_setup.is_mpr_my_boq_visible == '1') {
              i.is_view = true;
            }
            if (i.value == 'is_this_my_boq' && this.company_setup.is_mpr_my_boq_visible == '1') {
              i.is_view = true;
            }
            if (i.value == 'lead_time' && this.company_setup.is_mpr_buffer_stock_visible == '1') {
              i.is_view = true;
            }
            if (i.value == 'procured_days' && this.company_setup.is_mpr_buffer_stock_visible == '0') {
              i.is_view = false;
            }

          }
        }
        this.makeData();

        break;

      case 'stnreport':
        this.commonVariableList.columnList = globalVariables.stnVariableList.columnList;
        this.commonVariableList.items = this.tableDetails.data.product_details ? this.tableDetails.data.product_details : [];

        if (this.commonVariableList.columnList) {
          for (let i of this.commonVariableList.columnList) {
            if (i.value == 'product_catalog_id' && this.company_setup.product_catalog_id == '1') {
              i.is_view = true;
            }
            if (i.value == 'product_catalog_id' && this.company_setup.product_catalog_id == '0') {
              i.is_view = false;
            }
          }
        }
        this.makeData();

        break;
      case 'proformainvoicereport':
        this.commonVariableList.columnList = globalVariables.proformainvoiceVariableList.columnList;
        this.commonVariableList.items = this.tableDetails.data.invoice_items ? this.tableDetails.data.invoice_items : [];

        if (this.commonVariableList.columnList) {
          for (let i of this.commonVariableList.columnList) {
            if (i.value == 'product_catalog_id' && this.company_setup.product_catalog_id == '1') {
              i.is_view = true;
            }
            if (i.value == 'product_catalog_id' && this.company_setup.product_catalog_id == '0') {
              i.is_view = false;
            }
          }
        }
        this.makeData();

        break;
      case 'salesinvoicereport':
        this.commonVariableList.columnList = globalVariables.salesinvoiceVariableList.columnList;
        this.commonVariableList.items = this.tableDetails.data.invoice_items ? this.tableDetails.data.invoice_items : [];

        if (this.commonVariableList.columnList) {
          for (let i of this.commonVariableList.columnList) {
            if (i.value == 'product_catalog_id' && this.company_setup.product_catalog_id == '1') {
              i.is_view = true;
            }
            if (i.value == 'product_catalog_id' && this.company_setup.product_catalog_id == '0') {
              i.is_view = false;
            }
          }
        }
        this.makeData();

        break;
      case 'invoicepaymentreport':
        this.commonVariableList.columnList = globalVariables.invoicePaymentVariableList.columnList;
        this.commonVariableList.items = this.tableDetails.data.payment_details ? this.tableDetails.data.payment_details : [];
        this.makeData();

        break;
      case 'popaymentreport':
        this.commonVariableList.columnList = globalVariables.poPaymentVariableList.columnList;
        this.commonVariableList.items = this.tableDetails.data.payment_details ? this.tableDetails.data.payment_details : [];
        this.makeData();
        break;
      default:
        this.toasterService.pop('error', "Error", "Wrong Data For item table");
    }
  }
  makeData() {
    if (this.commonVariableList.items) {
      let sl_no: number = 1;
      for (let i of this.commonVariableList.items) {
        i.sl_no = sl_no;
        sl_no++;
      }
    }
    if (this.commonVariableList.columnList) {
      let sl_no: number = 1;
      for (let i of this.commonVariableList.columnList) {
        // i.sl_no=sl_no;

        i.tr_class = "";
        i.td_class = "";
        if (i.value == 'sl_no') {
          i.tr_class = i.tr_class + "action_tdfirst_sticky fixed_th testing_th_" + i.value
          i.td_class = i.td_class + "action_tdfirst_sticky testing_td_" + i.value
        }
        else if (i.value == 'product_name') {
          i.tr_class = i.tr_class + "action_tdsecond_sticky fixed_th testing_th_" + i.value
          i.td_class = i.td_class + "action_tdsecond_sticky testing_td_" + i.value
        }
        else if (i.value == 'product_description' || i.value == 'description') {
          i.tr_class = i.tr_class + "product_description testing_th_" + i.value
          i.td_class = i.td_class + "product_description testing_td_" + i.value
        }
        else if (i.value == 'make') {
          i.tr_class = i.tr_class + "make_width testing_th_" + i.value
          i.td_class = i.td_class + "make_width testing_td_" + i.value
        }
        else if (i.value == 'model') {
          i.tr_class = i.tr_class + "model_width testing_th_" + i.value
          i.td_class = i.td_class + "model_width testing_td_" + i.value
        }
        else if (i.value == 'additional_field1') {
          i.tr_class = i.tr_class + "additional_field1_width testing_th_" + i.value
          i.td_class = i.td_class + "additional_field1_width testing_td_" + i.value
        }
        else if (i.value == 'additional_field2') {
          i.tr_class = i.tr_class + "additional_field2_width testing_th_" + i.value
          i.td_class = i.td_class + "additional_field2_width testing_td_" + i.value
        }
        else {
          i.tr_class = "testing_th_" + i.value
          i.td_class = "testing_td_" + i.value
        }

        i.tr_class = i.tr_class + " testing_th_index_" + sl_no;
        i.td_class = i.td_class + " testing_td_index_" + sl_no+' span_ansr';
        sl_no++;
      }
    }
  }
  eventAction(data, data2) {
    let payload: any = {};
    let url: any = '';
    switch (data.value) {
      case 'qrcode_file_url':
        payload.product_id = [data2.product_id];
        payload.grn_id = data2.grn_id ? data2.grn_id : data2.id;
        payload.has_approved_once=this.tableDetails.data.has_approved_once?this.tableDetails.data.has_approved_once:''
        payload.irn_id=this.tableDetails.data.irn_id?this.tableDetails.data.irn_id:''
        payload.start = '';
        payload.limit = '';
        url = data.event.url;
        break;
      case 'barcode_file_url':
        payload.product_id = [data2.product_id];
        payload.grn_id = data2.grn_id ? data2.grn_id : data2.id;
        payload.has_approved_once=this.tableDetails.data.has_approved_once?this.tableDetails.data.has_approved_once:''
        payload.irn_id=this.tableDetails.data.irn_id?this.tableDetails.data.irn_id:''
        payload.start = '';
        payload.limit = '';
        url = data.event.url;
        break;
      default:
        payload = {};
        url = '';
    }
    this.downLoadFile(url, payload)

  }
  downLoadFile(url, payload) {
    if (url == undefined || url == '') {
      return;
    }

    this.webService.commonPostMethod(url, payload).subscribe(
      data => {
        if (data.status) {
          // window.location.href = data.file_path;
          window.open(data.file_path, '_blank')
        } else {
          this.toasterService.pop("error", "Error", data.message);
        }
      },
      error => {
        this.toasterService.pop("error", "Error", "Something went wrong")
      })
  }
  allowedDecimalDigit (key) {
    let allowedKeys = ["invoice_qty", "accepted_qty", "free_qty", "rejected_qty", "conversion_unit_price", "po_unit_price", "conversion_invoice_price",
      "invoice_unit_price", "conversion_paid_price", "paid_unit_price", "difference_unit_price"];

    if(allowedKeys.includes(key)) {
      return true;
    } else {
      return false;
    }
  }
  getPrColumnName(key, default_data) {
    if (key == '' || key == undefined) {
      return default_data ? default_data : '-';
    }
    if (this.company_setup.select_pr_list.length == undefined || this.company_setup.select_pr_list.length <= 0) {
      return default_data ? default_data : '-';

    }
    let temp: any = [];

    temp = this.company_setup.select_pr_list[0].columns.filter((v) => { return v.key == key });

    if (temp.length == undefined || temp.length <= 0) {
      return default_data ? default_data : '-';
    }
    return temp[0].custom_name ? temp[0].custom_name : '-'
  }
  is_pr_column_visible(key, default_data) {
    if (key == '' || key == undefined) {
      return default_data ? default_data : false;
    }
    if (this.company_setup.select_pr_list.length == undefined || this.company_setup.select_pr_list.length <= 0) {
      return default_data ? default_data : false;

    }

    let temp: any = [];
    temp = this.company_setup.select_pr_list[0].columns.filter((v) => { return v.key == key });
    if (temp.length == undefined || temp.length <= 0) {
      return default_data ? default_data : false;
    }
    return temp[0].is_visible ? temp[0].is_visible : false
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3957658806/src/src/app/generic-ui-components/generic-accordion-items/generic-accordion-items.component.ts